/**
 * Toolbox URLs from the SER-1471 "Toolbox URLs.xlsx" sheet, keyed by the
 * sheet's own `language_LOCATION` tokens. The de_AEG row is marked "not used"
 * in the sheet and is intentionally excluded.
 *
 * hu_HU and zh_CN are unreachable via language matching (hu/zh are not
 * app-supported languages); zh_CN is served via the China-deployment override.
 * They are kept to mirror the source sheet — do not "fix" them.
 */
export const TOOLBOX_URLS = new Map<string, string>([
  ['de_DE', 'https://www.stiebel-eltron.de/toolbox/home'],
  ['de_AT', 'https://www.stiebel-eltron.at/toolbox/home'],
  ['de_CH', 'https://www.stiebel-eltron.ch/toolbox/home'],
  ['de_INT', 'https://www.stiebel-eltron.com/toolbox/de/home'],
  ['de_TEC', 'https://www.tecalor.de/toolbox/home'],
  ['en_INT', 'https://www.stiebel-eltron.com/toolbox/home'],
  ['en_DE', 'https://www.stiebel-eltron.de/toolbox/en/home'],
  ['en_UK', 'https://www.stiebel-eltron.co.uk/toolbox/home'],
  ['en_IE', 'https://www.stiebel-eltron.ie/toolbox/home'],
  ['en_AU', 'https://www.stiebel-eltron.com/toolbox/au/home'],
  ['en_NZ', 'https://www.stiebel-eltron.com/toolbox/nz/home'],
  ['en_US', 'https://www.stiebel-eltron.com/toolbox/us/home'],
  ['en_IN', 'https://www.stiebel-eltron.in/toolbox/home'],
  ['en_ZA', 'https://www.stiebel-eltron.co.za/toolbox/home'],
  ['en_CN', 'https://www.stiebel-eltron.com/toolbox/cn/home'],
  ['en_TH', 'https://www.stiebel-eltron.co.th/toolbox/home'],
  ['en_VT', 'https://www.stiebel-eltron.vn/toolbox/home'],
  ['fr_FR', 'https://www.stiebel-eltron.fr/toolbox/home'],
  ['fr_BE', 'https://www.stiebel-eltron.be/toolbox/fr/home'],
  ['fr_CH', 'https://www.stiebel-eltron.ch/toolbox/fr/home'],
  ['nl_NL', 'https://www.stiebel-eltron.nl/toolbox/home'],
  ['nl_BE', 'https://www.stiebel-eltron.be/toolbox/nl/home'],
  ['fi_FI', 'https://www.stiebel-eltron.com/toolbox/fi/home'],
  ['sk_SK', 'https://www.stiebel-eltron.sk/toolbox/home'],
  ['cs_CZ', 'https://www.stiebel-eltron.cz/toolbox/home'],
  ['pl_PL', 'https://www.stiebel-eltron.pl/toolbox/home'],
  ['it_IT', 'https://www.stiebel-eltron.it/toolbox/home'],
  ['ru_RU', 'https://www.stiebel-eltron.com/toolbox/ru/home'],
  ['hu_HU', 'https://www.stiebel-eltron.hu/toolbox/home'],
  ['zh_CN', 'https://www.stiebel-eltron.com/toolbox/cn/home'],
]);

/** DEFAULT-marked row per language (spec: "Language default" fallback). */
export const LANGUAGE_DEFAULTS = new Map<string, string>([
  ['de', 'de_INT'],
  ['en', 'en_INT'],
  ['fr', 'fr_FR'],
  ['nl', 'nl_NL'],
  ['fi', 'fi_FI'],
  ['sk', 'sk_SK'],
  ['cs', 'cs_CZ'],
  ['pl', 'pl_PL'],
  ['it', 'it_IT'],
  ['ru', 'ru_RU'],
  ['hu', 'hu_HU'],
]);

/** The sheet uses non-ISO location tokens for these countries. */
export const COUNTRY_CODE_ALIASES = new Map<string, string>([
  ['GB', 'UK'],
  ['VN', 'VT'],
]);

export const TECALOR_TOOLBOX_URL = TOOLBOX_URLS.get('de_TEC')!;
export const CHINA_TOOLBOX_URL = TOOLBOX_URLS.get('zh_CN')!;
export const DEFAULT_TOOLBOX_URL = TOOLBOX_URLS.get('en_INT')!;
